import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LoggerStatus,
} from 'app/enums/label.enums'
import {
    LoggerResponse,
} from '../Loggers.types'
import {
    availableLoggerStatuses,
} from '../Logger/Logger.utils'

export type LoggerCreate = {
    softwareVersion: string,
    hardwareVersion: string,
}

type LoggerFields = keyof LoggerCreate | keyof LoggerResponse

const loggerCreateFields = (
    loggerStatus: LoggerStatus,
): DTOCardFormField<LoggerFields>[] => {
    return [{
        id: 'loggers',
        title: 'Logger',
        className: 'loggers',
        fields: [
            {
                id: 'loggers-column1',
                fields: [
                    {
                        name: 'loggerNumber',
                        componentName: 'InputSingleline',
                        required: true,
                        labelKey: 'LOGGER',
                    },
                    {
                        name: 'loggerQrCode',
                        componentName: 'InputSingleline',
                        required: true,
                        labelKey: 'LOGGER_QR_CODE',
                    },
                    {
                        name: 'loggerStatus',
                        componentName: 'EnumSelector',
                        required: true,
                        useDropdown: true,
                        value: loggerStatus || LoggerStatus.ACTIVE,
                        allowedValues: availableLoggerStatuses,
                        labelKey: 'LOGGER_STATUS',
                    },
                    {
                        name: 'loggerType',
                        componentName: 'LoggerTypeSelector',
                        required: true,
                        labelKey: 'LOGGER_TYPE',
                    },
                ],
            },
            {
                id: 'loggers-column2',
                fields: [
                    {
                        name: 'hardwareVersion',
                        componentName: 'InputSingleline',
                        labelKey: 'HARDWARE_VERSION',
                    },
                    {
                        name: 'softwareVersion',
                        componentName: 'InputSingleline',
                        labelKey: 'SOFTWARE_VERSION',
                    },
                    {
                        name: 'destinationLocation',
                        componentName: 'LocationObjectSelector',
                        labelKey: 'DESTINATION_LOCATION',
                    },
                ],
            },
            {
                id: 'loggers-column3',
                fields: [
                    {
                        name: 'temperatureTransmissionRateSecondsStationary',
                        componentName: 'IntegerInput',
                        labelKey: 'TEMPERATURE_TRANSMISSION_RATE_SECONDS_STATIONARY',
                    },
                    {
                        name: 'temperatureTransmissionRateSecondsMoving',
                        componentName: 'IntegerInput',
                        labelKey: 'TEMPERATURE_TRANSMISSION_RATE_SECONDS_MOVING',
                    },
                    {
                        name: 'measurementIntervalSeconds',
                        componentName: 'IntegerInput',
                        labelKey: 'LOGGER_MEASUREMENT_INTERVAL_SECONDS',
                    },
                ],
            },

        ],
    }]
}

export default loggerCreateFields
